import {
  SET_BLOCK
} from 'src/store/mutation-types'

const setBlock = ({commit}, block) => {
  commit(SET_BLOCK, block)
}
export default{
  setBlock
}



// WEBPACK FOOTER //
// ./src/components/block/store/actions.js